module.exports = __webpack_public_path__ + "static/img/13.9a34dc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/zh/13.png
// module id = DD9s
// module chunks = 0